"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = function () {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  var day = date.getDate().toString();
  if (day.length === 1) day = "0" + day;
  var month = (date.getMonth() + 1).toString();
  if (month.length === 1) month = "0" + month;
  return [day, month, date.getFullYear().toString()];
};